// src/App.js
import { useState } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import Contact from './component/contact';
import Footer from './component/footer';
import Header from './component/header';
import Menu from './component/menu';
import PurchasePage from './component/purshace';
import Stats from './component/stats';
import VideoShow from './component/videoShow';
import ProductCard from './component/viewProduct';


const App = () => {
   const [isCartOpen, setIsCartOpen] = useState(false);
  return (
     <Router>
      <Header />
      <Routes>
        <Route path="/" element={<>   
         <div className="App">
          <Header />
          {/* <Home /> */}
          {/* <About /> */}
          <Menu />
          {/* <Services /> */}
          <Stats />
          {/* <Team /> */}
          <VideoShow />
          <Contact />
          <Footer />
        </div>
    </>} />
        <Route path="/purchase" element={<PurchasePage />} />
        <Route path="/view-product" element={<ProductCard />} />
      </Routes>
    </Router>
  );
}



export default App;